import React, { useEffect } from "react";
import { Grid, Typography, Button, useTheme } from "@material-ui/core";
import SelectPhoto from "./SelectPhoto";
import VehicleInfo from "./VehicleInfo";
import FrontDriver from "./FrontDriver";
import BackDriver from "./BackDriver";
import Damages from "./Damages";
import OtherPhotos from "./OtherPhotos";

import { PhotoUploaderStyles } from "./PhotoUploaderStyles";
import * as _ from "lodash";
import { PhotoProgressBar } from "./PhotoProgressBar";
import PhotoLandingPage from "./PhotoLandingPage";
import ErrorPage from "./ErrorPage";

import { PerformCAuth } from "./services/PerformCAuth";
import { CCCResponse } from "./model/CCCResponse";
import { UrlResolver } from "../util/UrlResolver";
import { useLocation } from "react-router-dom";
import { validateSession } from "./services/validateSessionApi";
import ModalLinearActivityIndicator from "./modalLinearActivityIndicator/ModalLinearActivityIndicator";
import LoadingSpinner from "./LoadingSpinner";
import { currentThemeName } from "../themes/themeMapper";
import { uploadPhotosBtn } from "../constants/GlobalConstants";

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}
const performCancel = async () => {
  window.parent.postMessage(
    { messageName: "POST_FNOL_GO_TO_CLAIM", claimNumber: "NA" },
    "*",
  );
};
export interface CAuth {
  success: boolean;
  content: string;
  errorCode: string;
  errorMessage: string;
  failedCount: number;
}

function removeFileExtension(fileName) {
  // Find the last occurrence of the dot character
  const lastDotIndex = fileName.lastIndexOf(".");
  // If there's no dot, return the original file name
  if (lastDotIndex === -1) {
    return fileName;
  }
  // Return the substring from the start to the last dot index
  return fileName.substring(0, lastDotIndex);
}

const PhotoUploader = (props: any) => {
  const DEFAULT_UPLOAD_STATUS = {
    isUploadComplete: false,
    isSuccess: false,
    failedMsg: "",
  };
  const theme = useTheme();
  const classes = PhotoUploaderStyles();
  const [nuxeoUploadPhotoList, setNuxeoUploadPhotoList] = React.useState([]);
  const [showProgress, setShowProgress] = React.useState(false);
  const [uploadStatus, setUploadStatus] = React.useState(DEFAULT_UPLOAD_STATUS);
  const [photoCount, setPhotoCount] = React.useState<number>(0);
  const [flag, setFlag] = React.useState(false);
  const [initiating, setInitiate] = React.useState(true);
  const [showErrorPage, setShowErrorPage] = React.useState<number>(0);
  const [vinFile, setVinFile] = React.useState([]);
  const [odoFile, setOdoFile] = React.useState([]);
  const [fdsFile, setFdsFile] = React.useState([]);
  const [fpsFile, setFpsFile] = React.useState([]);
  const [bdsFile, setBdsFile] = React.useState([]);
  const [bpsFile, setBpsFile] = React.useState([]);
  const [lsdFile, setLsdFile] = React.useState([]);
  const [cdFile, setCdFile] = React.useState([]);
  const [rsdFile, setRsdFile] = React.useState([]);
  const [cccPhotoUpdateCount, setCCCPhotoUpdateCount] =
    React.useState<number>(0);
  const [urlKey, setUrlKey] = React.useState("");
  const [custKey, setCustKey] = React.useState("");
  const [refNum, setRefNum] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [claimNumber, setClaimNumber] = React.useState("");

  const query = useQuery();

  useEffect(() => {
    setUrlKey(query.get("urlKey"));
    setCustKey(query.get("custKey"));
    setRefNum(query.get("refNum"));
    setLastName(query.get("lastName"));
    setClaimNumber(query.get("claimNumber"));
    window.history.replaceState(null, "Photo Uploader", "/uploadPhotos");
  }, [query]);

  // Call out to validate and toggle variable to run loading spinner while we wait for a response

  useEffect(() => {
    /**
     *
     * @param urlKey - UrlKey used to identify user
     * @param custKey - Auth token for user at a given time
     */
    async function performValidation(
      urlKey: string,
      custKey: string,
    ): Promise<void> {
      if (urlKey && custKey && !!initiating) {
        // Get Context Router Response
        const response: any = await validateSession(urlKey, custKey);
        window.parent.postMessage({ messageName: "PHOTO_LOAD_COMPLETE" }, "*");

        if (_.get(response, "status.statusCode") === 200) {
          setInitiate(false);
          const fullClaimNumber = _.get(
            response,
            "data.claimsInfo.fullClaimNumber",
            "",
          );
          if (fullClaimNumber) {
            setClaimNumber(_.get(response, "data.claimsInfo.fullClaimNumber"));
          }
          setCustKey(_.get(response, "data.updatedAuthToken", custKey));
          window.parent.postMessage(
            {
              messageName: "POST_FNOL_UPDATE_CUSTKEY",
              urlKey: urlKey,
              custKey: _.get(response, "data.updatedAuthToken", custKey),
            },
            "*",
          );
        } else {
          setShowErrorPage(1);
        }
      }
    }
    performValidation(urlKey, custKey);
  }, [urlKey, custKey, initiating]);

  const isCCCPhotoUpload = !!(refNum && lastName);
  const minimumPhotosForCCC = 9;
  const minimumPhotosForNuxeo = 1;

  const performPhotoUpload = async () => {
    setShowErrorPage(0);
    try {
      console.log("Validation: ");
      let uploadStatus = DEFAULT_UPLOAD_STATUS;
      if (isCCCPhotoUpload) {
        setShowProgress(true);
        mapPhotoList();
        console.log("ccc upload");
        let result: CAuth = await performCCCUploadDocsMultiple();
        console.log(result.success);
        if (result.success) {
          uploadStatus.isUploadComplete = true;
          uploadStatus.isSuccess = true;
          const uploadedPhotoCnt =
            nuxeoUploadPhotoList.length - result.failedCount;
          setPhotoCount(uploadedPhotoCnt);

          console.log("Upload completed!!!!", result.success);
          window.parent.postMessage(
            { messageName: "PHOTO_UPLOAD_SUCCESS", uploadedPhotoCnt },
            "*",
          );
        } else {
          let errorMsg = result.errorMessage;
          window.parent.postMessage(
            { messageName: "PHOTO_UPLOAD_FAILED_WITH_ERROR", errorMsg },
            "*",
          );
          console.log("Upload failed with error!!!!", result.errorMessage);
          uploadStatus.isUploadComplete = true;
          uploadStatus.isSuccess = false;
          uploadStatus.failedMsg = result.errorMessage;
        }
        setShowProgress(false);
        setUploadStatus(uploadStatus);
        setNuxeoUploadPhotoList([]);
        setFlag(true);
      } else {
        // Not CCC Photo upload, Nuxeo upload.
        setShowProgress(true);
        mapPhotoList();
        console.log("Nuxeo upload");
        let result: any = await performNuxeoUploadDocsMultiple();
        if (result) {
          uploadStatus.isUploadComplete = true;
          uploadStatus.isSuccess = true;
          const uploadedPhotoCnt =
            nuxeoUploadPhotoList.length - result.failedCount;
          setPhotoCount(uploadedPhotoCnt);

          window.parent.postMessage(
            { messageName: "PHOTO_UPLOAD_SUCCESS", uploadedPhotoCnt },
            "*",
          );
        } else {
          let errorMsg = result.errorMessage;
          window.parent.postMessage(
            { messageName: "PHOTO_UPLOAD_FAILED_WITH_ERROR", errorMsg },
            "*",
          );
          uploadStatus.isUploadComplete = true;
          uploadStatus.isSuccess = false;
          uploadStatus.failedMsg = result.errorMessage;
        }
        setShowProgress(false);
        setUploadStatus(uploadStatus);

        setNuxeoUploadPhotoList([]);
        setFlag(true);
      }
    } catch (ex) {
      window.parent.postMessage({ messageName: "PHOTO_UPLOAD_FAILED" }, "*");
      setShowErrorPage(1);
      console.log(
        "CCC PhotoUploadModal - performPhotoUpload - Error in uploading!!!" +
          ex +
          "   " +
          showErrorPage,
      );
      setUploadStatus(uploadStatus);
      setShowProgress(false);
    }
  };

  // Hanldes upload to Nuxeo via Claims Docs API
  async function performNuxeoUploadDocsMultiple() {
    const endpoint = UrlResolver.resolveBaseUrl();
    const url = endpoint + `/imageUploadNuxeo/${claimNumber}`;
    try {
      let fetchArr = [];
      console.log("file count: " + nuxeoUploadPhotoList.length);
      nuxeoUploadPhotoList.forEach((file1) => {
        console.log(file1.name);
      });
      nuxeoUploadPhotoList.forEach((file) => {
        let metaData = {
          claimNumber: claimNumber,
          title: removeFileExtension(file.imageDisplayFileName),
          leg: UrlResolver.resolveNuxeoLeg(),
        };

        let formdata = new FormData();
        formdata.append("metadata", JSON.stringify(metaData));
        formdata.append("file", file);
        fetchArr.push(
          fetch(url, {
            method: "POST",
            headers: {
              urlid: urlKey,
              Authorization: "Bearer " + custKey,
              Accept: "*/*",
            },
            body: formdata,
            redirect: "follow",
          }),
        );
      });
      const respResult = await Promise.all(fetchArr)
        .then((results) => Promise.all(results.map((value) => value.json())))
        .then((responses) => {
          console.log(responses);
          return responses;
        })
        .catch((error) => {
          setShowErrorPage(1);
          console.log("Error:" + error + "    " + showErrorPage);
        });
      return Validate_resp(respResult);
    } catch (e) {
      setShowErrorPage(1);
      console.log("Error:" + e + "    " + showErrorPage);
    }
  }

  // Handles multi-step upload to CCC if user is eligible for CCC upload
  async function performCCCUploadDocsMultiple() {
    const endPoint = UrlResolver.resolveCCCUrl();
    try {
      const result: CCCResponse = await PerformCAuth(
        refNum,
        lastName,
        urlKey,
        custKey,
        nuxeoUploadPhotoList.length,
      );
      console.log("C Auth results " + result.content + "   " + result.success);
      if (result.success === true) {
        const saml = result.saml;
        let url =
          `${endPoint}/s/imageUpload?uuid=` +
          result.content +
          `&imageCaptureDate=${new Date().toISOString()}&imgTakenByLastName=${lastName}&imgDisplayOrder=1`;
        let fetchArr = [];
        console.log("file count" + nuxeoUploadPhotoList.length);
        nuxeoUploadPhotoList.forEach((file1) => {
          console.log(file1.name);
        });
        nuxeoUploadPhotoList.forEach((file) => {
          let formdata = new FormData();
          console.log(
            "File Details " +
              file.name +
              "  " +
              file.imageLabel +
              "   " +
              file.imageDisplayFileName +
              "    " +
              file.additionalDescription,
          );
          formdata.append("file", file);
          formdata.append("imageLabel", file.imageLabel);
          formdata.append("imageDisplayFileName", file.imageDisplayFileName);
          formdata.set("additionalDescription", file.additionalDescription);
          formdata.set("allowRetake", "true");

          fetchArr.push(
            fetch(url, {
              method: "POST",
              headers: { "saml-auth": saml },
              body: formdata,
              redirect: "follow",
            }),
          );
        });
        const respResult = await Promise.all(fetchArr)
          .then((results) => Promise.all(results.map((value) => value.json())))
          .then((responses) => {
            console.log(responses);
            return responses;
          })
          .catch((error) => {
            setShowErrorPage(1);
            console.log("Error:" + error + "    " + showErrorPage);
          });
        return Validate_resp(respResult);
      } else {
        setShowErrorPage(1);
      }
    } catch (ex) {
      console.log("performCCCUploadDocsMultiple - Error in uploading!!!" + ex);
    }
  }

  function Validate_resp(responses) {
    console.log(responses);
    let resultObj = {
      success: true,
      content: "",
      errorMessage: "",
      errorCode: "",
      errorSource: "",
      failedCount: 0,
    };
    let count: number = 0;
    responses.forEach((response) => {
      console.log(response.success);
      console.log(photoCount + "   " + response.success);
      console.log(response.success !== true);
      if (response.success !== true) {
        count = count + 1;

        console.log(photoCount);
      }
      if (response.success !== null) {
        resultObj.success = response.success;
        resultObj.content = response.content;
        resultObj.errorMessage = response.erroMessage;
        resultObj.errorCode = response.errorCode;
        resultObj.errorSource = response.errorSource;
      }
    });
    resultObj.failedCount = count;
    console.log("Upload Done!", resultObj);
    return resultObj;
  }

  // Added for Authenticate Claim NUmber/RefID with last Name - CCC Photo Upload
  async function performStartImageUpload1(
    saml,
    noPhotos,
    lossRef,
    urlKey: string,
    custKey: string,
  ) {
    const endPoint = UrlResolver.resolveBaseUrl();
    try {
      let validatePass = true;
      console.log("Validation: " + validatePass);
      let url = `${endPoint}/initiateCCCUpload`;
      let startImageData = {
        noPhotos: noPhotos,
        lossRef: lossRef,
        saml: saml,
      };

      // let saml = result.content;
      console.log("This is SAML Header information" + saml);
      return await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          urlid: urlKey,
          Authorization: "Bearer " + custKey,
        },
        body: JSON.stringify(startImageData),
      })
        .then((r) => r.json())
        .then((res) => {
          if (res) {
            return res;
          }
        });
    } catch (ex) {
      setShowErrorPage(1);
      console.log("performStartImageUpload - Error in uploading!!!" + ex);
    }
  }

  function updatePhotoFile(file) {
    console.log(file.imageLabel);
    if (file.imageLabel === "VIN") {
      let fileVinArr = vinFile === undefined ? [] : vinFile;
      fileVinArr.push(file);
      setVinFile(fileVinArr);
      let updateCount = cccPhotoUpdateCount === 0 ? 0 : cccPhotoUpdateCount;
      setCCCPhotoUpdateCount(updateCount + 1);
    }
    if (file.imageLabel === "Odometer") {
      let fileOdoArr = odoFile === undefined ? [] : odoFile;
      fileOdoArr.push(file);
      setOdoFile(fileOdoArr);
      let updateCount = cccPhotoUpdateCount === 0 ? 0 : cccPhotoUpdateCount;
      setCCCPhotoUpdateCount(updateCount + 1);
    }
    if (file.imageLabel === "Driver Side Front") {
      let fileFdsArr = fdsFile === undefined ? [] : fdsFile;
      fileFdsArr.push(file);
      setFdsFile(fileFdsArr);
      let updateCount = cccPhotoUpdateCount === 0 ? 0 : cccPhotoUpdateCount;
      setCCCPhotoUpdateCount(updateCount + 1);
    }
    if (file.imageLabel === "Passenger Side Front") {
      let fileFpsArr = fpsFile === undefined ? [] : fpsFile;
      fileFpsArr.push(file);
      setFpsFile(fileFpsArr);
      let updateCount = cccPhotoUpdateCount === 0 ? 0 : cccPhotoUpdateCount;
      setCCCPhotoUpdateCount(updateCount + 1);
    }
    if (file.imageLabel === "Driver Side Back") {
      let fileBdsArr = bdsFile === undefined ? [] : bdsFile;
      fileBdsArr.push(file);
      setBdsFile(fileBdsArr);
      let updateCount = cccPhotoUpdateCount === 0 ? 0 : cccPhotoUpdateCount;
      setCCCPhotoUpdateCount(updateCount + 1);
    }
    if (file.imageLabel === "Passenger Side Back") {
      let fileBpsArr = bpsFile === undefined ? [] : bpsFile;
      fileBpsArr.push(file);
      setBpsFile(fileBpsArr);
      let updateCount = cccPhotoUpdateCount === 0 ? 0 : cccPhotoUpdateCount;
      setCCCPhotoUpdateCount(updateCount + 1);
    }
    if (file.imageLabel === "Damage - Left Angle") {
      let fileLsdArr = lsdFile === undefined ? [] : lsdFile;
      fileLsdArr.push(file);
      setLsdFile(fileLsdArr);
      let updateCount = cccPhotoUpdateCount === 0 ? 0 : cccPhotoUpdateCount;
      setCCCPhotoUpdateCount(updateCount + 1);
    }
    if (file.imageLabel === "Damage - Center") {
      let fileCdArr = cdFile === undefined ? [] : cdFile;
      fileCdArr.push(file);
      setCdFile(fileCdArr);
      let updateCount = cccPhotoUpdateCount === 0 ? 0 : cccPhotoUpdateCount;
      setCCCPhotoUpdateCount(updateCount + 1);
    }
    if (file.imageLabel === "Damage - Right Angle") {
      let fileRsdArr = rsdFile === undefined ? [] : rsdFile;
      fileRsdArr.push(file);
      setRsdFile(fileRsdArr);
      let updateCount = cccPhotoUpdateCount === 0 ? 0 : cccPhotoUpdateCount;
      setCCCPhotoUpdateCount(updateCount + 1);
    }
  }

  function deleteVinFile() {
    setVinFile([]);
    console.log(vinFile.length);
    let updateCount = cccPhotoUpdateCount === 0 ? 0 : cccPhotoUpdateCount;
    setCCCPhotoUpdateCount(updateCount - 1);
  }
  function deleteOdoFile() {
    setOdoFile([]);
    console.log(odoFile.length);
    let updateCount = cccPhotoUpdateCount === 0 ? 0 : cccPhotoUpdateCount;
    setCCCPhotoUpdateCount(updateCount - 1);
  }
  function deleteFDSFile() {
    setFdsFile([]);
    let updateCount = cccPhotoUpdateCount === 0 ? 0 : cccPhotoUpdateCount;
    setCCCPhotoUpdateCount(updateCount - 1);
  }
  function deleteFPSFile() {
    setFpsFile([]);
    let updateCount = cccPhotoUpdateCount === 0 ? 0 : cccPhotoUpdateCount;
    setCCCPhotoUpdateCount(updateCount - 1);
  }
  function deleteBDSFile() {
    setBdsFile([]);
    let updateCount = cccPhotoUpdateCount === 0 ? 0 : cccPhotoUpdateCount;
    setCCCPhotoUpdateCount(updateCount - 1);
  }
  function deleteBPSFile() {
    setBpsFile([]);
    let updateCount = cccPhotoUpdateCount === 0 ? 0 : cccPhotoUpdateCount;
    setCCCPhotoUpdateCount(updateCount - 1);
  }
  function deleteLSDFile() {
    setLsdFile([]);
    let updateCount = cccPhotoUpdateCount === 0 ? 0 : cccPhotoUpdateCount;
    setCCCPhotoUpdateCount(updateCount - 1);
  }
  function deleteCDFile() {
    setCdFile([]);
    let updateCount = cccPhotoUpdateCount === 0 ? 0 : cccPhotoUpdateCount;
    setCCCPhotoUpdateCount(updateCount - 1);
  }
  function deleteRSDFile() {
    setRsdFile([]);
    let updateCount = cccPhotoUpdateCount === 0 ? 0 : cccPhotoUpdateCount;
    setCCCPhotoUpdateCount(updateCount - 1);
  }

  function deleteFile(file) {
    const deleteFile = nuxeoUploadPhotoList.filter(
      (item, index) => item !== file,
    );
    setNuxeoUploadPhotoList(deleteFile);
  }

  function updateFiles(files) {
    // Ensure nuxeoUploadPhotoList is initialized
    const existingPhotos = nuxeoUploadPhotoList || [];
    // Filter out files that are already in the existingPhotos list
    const newFiles = files.filter(
      (file) =>
        !existingPhotos.some((existingFile) => existingFile.name === file.name),
    );
    // Create a new array by spreading the existingPhotos and adding only new files
    const updatedPhotos = [...existingPhotos, ...newFiles];
    // Update the state with the new array
    setNuxeoUploadPhotoList(updatedPhotos);
    // Log the length of the updated nuxeoUploadPhotoList
    console.log("updatedPhotos.length", updatedPhotos.length);
    console.log("nuxeoUploadPhotoList", updatedPhotos.length);
  }

  function uploadedPhotoCount(count: any) {
    return count;
  }

  function mapPhotoList() {
    let allPhotos =
      nuxeoUploadPhotoList === undefined ? [] : nuxeoUploadPhotoList;
    vinFile.forEach((file) => {
      console.log(file.name);
      allPhotos.push(file);
    });
    odoFile.forEach((file) => {
      console.log(file.name);
      allPhotos.push(file);
    });
    fdsFile.forEach((file) => {
      console.log(file.name);
      allPhotos.push(file);
    });
    fpsFile.forEach((file) => {
      console.log(file.name);
      allPhotos.push(file);
    });
    bdsFile.forEach((file) => {
      console.log(file.name);
      allPhotos.push(file);
    });
    bpsFile.forEach((file) => {
      console.log(file.name);
      allPhotos.push(file);
    });
    lsdFile.forEach((file) => {
      console.log(file.name);
      allPhotos.push(file);
    });
    cdFile.forEach((file) => {
      console.log(file.name);
      allPhotos.push(file);
    });
    rsdFile.forEach((file) => {
      console.log(file.name);
      allPhotos.push(file);
    });
    setNuxeoUploadPhotoList(allPhotos);
  }

  const CCCPhotoUploadCompnent = (
    <>
      <Grid item xs={12}>
        <div style={{ width: "100%", margin: "auto" }}>
          <VehicleInfo
            updatePhotoFile={(file) => updatePhotoFile(file)}
            deleteVinFile={(file) => deleteVinFile()}
            deleteOdoFile={(file) => deleteOdoFile()}
          />
        </div>
      </Grid>
      <Grid item xs={12} spacing={1} container>
        <div style={{ width: "100%", margin: "auto" }}>
          <FrontDriver
            updatePhotoFile={(file) => updatePhotoFile(file)}
            deleteFDSFile={(file) => deleteFDSFile()}
            deleteFPSFile={(file) => deleteFPSFile()}
          />
        </div>
      </Grid>
      <Grid item xs={12} spacing={2} container>
        <div style={{ width: "100%", margin: "auto" }}>
          <BackDriver
            updatePhotoFile={(file) => updatePhotoFile(file)}
            deleteBDSFile={(file) => deleteBDSFile()}
            deleteBPSFile={(file) => deleteBPSFile()}
          />
        </div>
      </Grid>
      <Grid item xs={12} spacing={2} container>
        <div style={{ width: "100%", margin: "auto" }}>
          <Damages
            updatePhotoFile={(file) => updatePhotoFile(file)}
            deleteLSDFile={(file) => deleteLSDFile()}
            deleteCDFile={(file) => deleteCDFile()}
            deleteRSDFile={(file) => deleteRSDFile()}
          />
        </div>
      </Grid>
      <Grid item xs={12} spacing={2} container>
        <div style={{ width: "100%", margin: "auto" }}>
          <OtherPhotos
            updateFiles={(files) => updateFiles(files)}
            deleteFile={(file) => deleteFile(file)}
          />
        </div>
      </Grid>
      <Grid item xs={12} spacing={2} container>
        <Typography style={{ color: "white", marginBottom: "1rem" }}>
          -
        </Typography>
      </Grid>
    </>
  );

  const NuxeoPhotoUploadCompnent = (
    <>
      <Grid item xs={12} spacing={2} container>
        <div style={{ width: "100%", margin: "auto" }}>
          <OtherPhotos
            updateFiles={(files) => updateFiles(files)}
            deleteFile={(file) => deleteFile(file)}
          />
        </div>
      </Grid>
      <Grid item xs={12} spacing={2} container>
        <Typography style={{ color: "white", marginBottom: "1rem" }}>
          -
        </Typography>
      </Grid>
    </>
  );

  const isUploadButtonDisabled = isCCCPhotoUpload
    ? cccPhotoUpdateCount < minimumPhotosForCCC
    : nuxeoUploadPhotoList.length < minimumPhotosForNuxeo;

  const isAmfamTheme = currentThemeName === "amfamTheme";

  return (
    <div>
      {showErrorPage === 0 ? (
        !!initiating ? (
          isAmfamTheme ? (
            <ModalLinearActivityIndicator />
          ) : (
            <LoadingSpinner />
          )
        ) : !flag ? (
          <Grid container justify="center" spacing={1}>
            <Grid item xs={12}>
              <div style={{ width: "100%", margin: "auto" }}>
                <SelectPhoto isCCC={isCCCPhotoUpload} />
              </div>
            </Grid>
            {isCCCPhotoUpload && CCCPhotoUploadCompnent}
            {!isCCCPhotoUpload && NuxeoPhotoUploadCompnent}
            {showProgress ? (
              <Grid item xs={12} spacing={2} container>
                <div style={{ width: "100%", margin: "auto" }}>
                  <PhotoProgressBar />
                </div>
              </Grid>
            ) : (
              <Grid item xs={12} spacing={2} container>
                <div style={{ width: "100%", margin: "auto" }}>
                  <Grid container justify="flex-end">
                    <Grid item xs={12} justify="flex-end" container>
                      <Grid
                        container
                        className={classes.ctaRow}
                        justify="flex-end"
                      >
                        <Button
                          className={classes.btnColor}
                          style={{
                            height:
                              theme.custom.styles.uploadButton.height || "50px",
                          }}
                          color="primary"
                          variant="contained"
                          onClick={performPhotoUpload}
                          disabled={isUploadButtonDisabled}
                        >
                          {uploadPhotosBtn}
                        </Button>

                        <span className={classes.btnSpan}></span>
                        <Button
                          className={classes.cBtnColor}
                          color="primary"
                          variant="text"
                          onClick={performCancel}
                        >
                          Cancel
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
              </Grid>
            )}
            <Grid item xs={12} spacing={2} container>
              <Typography style={{ color: "white" }}>-</Typography>
            </Grid>
          </Grid>
        ) : (
          <PhotoLandingPage
            uploadedPhotoCount={uploadedPhotoCount(photoCount)}
          />
        )
      ) : (
        <Grid item xs={12} container>
          <div style={{ width: "100%", margin: "auto" }}>
            <ErrorPage />
          </div>
        </Grid>
      )}
    </div>
  );
};
export default PhotoUploader;
